<template>
 <div>
   <div class="container-fluid">
     <div class="aboutus-header">
       <div id="aboutus-header-bg"></div>
       <div class="header-text">
         <p>
         Direct from the Mills <br>
         to your doorstep Synergy <br>
         provides Full Sourcing <br>
         &nbsp; Procurement Services <br>
         </p> 
       </div>
     </div>
 
     <div class="mobile-img-header">
       <div>
         <div style="background-image:url('../../public/images/Profile-Aboutus.jpg');background-size:cover;background-repeat:no-repeat;width:100%;height:0;padding-top:52vh;position:relative;background-position:bottom;"></div>
         <div class="mobile-header-text">
           <p>
             Direct from the Mills <br>
         to your doorstep Synergy <br>
         provides Full Sourcing <br>
         &nbsp; Procurement Services <br>
           </p>
         </div>
       </div>
     </div>
   </div>
 
   <div class="container-fluid cont">
     <div id="mobile-about-header" >
       <p style="font-weight:bold;">
         The Synergy Advantage<br>
       </p>
       <p style="font-weight:bold;margin-left:30%;">
         Best Value,<br>
       </p>
       <p style="font-weight:bold;margin-left:40%;">
          Efficient,<br>
       </p>
       <p style="font-weight:bold;margin-left:50%;">
          Convenient.<br>
       </p>
     </div>
   </div>
   <div class="container-fluid cont">
     <div class="aboutus-content1">
       <div class="aboutus-content1-left">
         <img src="../../public/images/synergymodel.png" class="about-img" >
       </div>
       <div class="aboutus-content1-right">
         <div id="about-title">
         <p class="Mhome-Btitle">
           The Synergy Advantage<br>
         </p>
         <p class="Mhome-Btitle" style="margin-left:30%;">
           Best Value,<br>
         </p>
         <p class="Mhome-Btitle" style="margin-left:40%;">
           Efficient,<br>
         </p>
         <p class="Mhome-Btitle" style="margin-left:50%;">
           Convenient.<br>
         </p>
         </div>
         <!-- <div class="about-content1-right-subbox">
           <p>
             Traditional procurement models require many points of coordination - distributors, foreign
agents, logistics representatives, inspection agent, and customs clearance
specialist – all adding cost, schedule, and risk to the purchased product.
           </p>
         </div> -->
         
         <div id="about-text">
           <p class="about-text" style="margin-bottom:35px;">
           Traditional procurement models require many points of coordination - distributors, foreign
agents, logistics representatives, inspection agent, and customs clearance
specialist – all adding cost, schedule, and risk to the purchased product.
         </p>
         <p class="about-text-title">The Best of the East supplied to the West.</p>
         <p class="about-text">
           Synergy International Metals (SIM) is a knowledgeable and dedicated team of professionals focused on reducing cost and risk for our clients through managing the supply chain and eliminating unnecessary process steps to provide Just In Time delivery. Whether it is project pipe fittings, pipe flanges, bulk material, stock material, or custom industrial forging, SIM guarantees timely and superior service that is catered for our customers specific needs<br><br>
          The Synergy model achieves better value through efficiency in the following ways:<br>
          <ul style="margin:12px 0 0 5%;">
          <li>We offer a large array of core products which allows our clients to consolidate multiple commodities and maximize their purchasing power resulting as direct savings to them.</li>
          <li>Our product pricing includes managing the full supply cycle - from the Mill through our Supply Chain &nbsp; Logistics to our client’s destination.</li>
          <li>SIM procurement service includes all logistics, customs, and inspection services required to deliver our products to our client’s site.</li>
          </ul><br>
          Synergy is able to accomplish this because we have spent years building relationships and fostering the growth of our company and our supply chain partners. Additionally, our principals have lived and built relationships in Asia for many years allowing them to understand the culture and traditions on both sides of the world. These relationships are at the core of our business principals.
         </p>
         <router-link to="/products">
           <div class="btn-group-lg" style="margin-top:40px;display:inline-block;">
             <button type="button" class="btn btn-primary" style="background: #305CA2; border-radius: 10px 0 0 10px; border: none; font-size: 17px; padding: 10px 21px;width: 244px;">View our Full Catalog</button>
             <button type="button" class="btn btn-primary btn-default btn-sm" style="background: #5d7cad; border-radius: 0 10px 10px 0; border: none; font-size: 17px; padding: 10px 13px"><img src="../../public/images/right-arrow.svg" style="width: 18px;" ></button>
           </div>
         </router-link>
         </div>
       </div>
     </div>
   </div>
 
   <!-- <div class="container-fluid" id="mobile-about-bot">
     <div id="mobile-subbox">
       <p>
         Traditional procurement models require many points of coordination - distributors, foreign
agents, logistics representatives, inspection agent, and customs clearance
specialist – all adding cost, schedule, and risk to the purchased product.
       </p>
     </div>
   </div> -->
   <div class="container-fluid cont" id="mobile-about-text">
     <p class="about-text" style="margin-bottom:35px;">
      Traditional procurement models require many points of coordination - distributors, foreign
agents, logistics representatives, inspection agent, and customs clearance
specialist – all adding cost, schedule, and risk to the purchased product.
         </p>
     <p class="about-text-title">The Best of the East supplied to the West.</p>
       <p class="about-text">
           Synergy International Metals (SIM) is a knowledgeable and dedicated team of professionals focused on reducing cost and risk for our clients through managing the supply chain and eliminating unnecessary process steps to provide Just In Time delivery. Whether it is project pipe fittings, pipe flanges, bulk material, stock material, or custom industrial forging, SIM guarantees timely and superior service that is catered for our customers specific needs<br><br>
          The Synergy model achieves better value through efficiency in the following ways:<br>
          <ul style="margin:12px 0 0 5%;">
          <li>We offer a large array of core products which allows our clients to consolidate multiple commodities and maximize their purchasing power resulting as direct savings to them.</li>
          <li>Our product pricing includes managing the full supply cycle - from the Mill through our Supply Chain &nbsp; Logistics to our client’s destination.</li>
          <li>SIM procurement service includes all logistics, customs, and inspection services required to deliver our products to our client’s site.</li>
          </ul><br>
          Synergy is able to accomplish this because we have spent years building relationships and fostering the growth of our company and our supply chain partners. Additionally, our principals have lived and built relationships in Asia for many years allowing them to understand the culture and traditions on both sides of the world. These relationships are at the core of our business principals.
         </p>
         <router-link to="/products">
           <div class="btn-group-lg" style="margin-top:40px;display:inline-block;">
             <button type="button" class="btn btn-primary" style="background: #305CA2; border-radius: 10px 0 0 10px; border: none; font-size: 17px; padding: 10px 21px;width: 244px;">View our Full Catalog</button>
             <button type="button" class="btn btn-primary btn-default btn-sm" style="background: #5d7cad; border-radius: 0 10px 10px 0; border: none; font-size: 17px; padding: 10px 13px"><img src="../../public/images/right-arrow.svg" style="width: 18px;" ></button>
           </div>
         </router-link>
   </div>
   <router-view></router-view>
 </div>
</template>
 
<script>
  export default {
    name: 'Profile',
    head: {
      script: [
        { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=G-J75XDBGTR6', async: true, body: false}, // Insert in bod
      ],
    },
  }

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-J75XDBGTR6');
</script>
 
<style scoped>
 * {
   box-sizing: border-box;
   margin: 0;
   padding: 0;
   font-family: 'Forma DJR Micro', sans-serif;
 }
 .cont {
   padding: 0 7% 0 7%;
 }
 .aboutus-header {
   background: url("../../public/images/Profile-Aboutus.jpg");
   background-size: cover;
   background-repeat: no-repeat;
   width: 100%;
   position: relative;
   background-position: center;
 }
 #aboutus-header-bg {
   background-image:url('../../public/images/Profile-Aboutus.jpg');
   background-size: cover;
   background-repeat:no-repeat;
   width:100%;
   height:0;
   padding-top:35%;
   position:relative;
   visibility:hidden;
   background-position: center;
 }
 .mobile-img-header {
   background: url("../../public/images/Profile-Aboutus.jpg") bottom;
   background-size: cover;
   background-repeat: no-repeat;
   width: 100%;
   position: relative;
   display: none;
   background-position:bottom;
 }
 #profile-section-text {
   font-size: 17px;
   line-height: 32px;
   margin-top: 20px;
   text-align: justify;
 }
 #header-gDash {
   width:70%;
   /* max-width:1080px; */
   height:3px;
   background:#00C5BC;
   position:absolute;
   bottom:17%;
 }
 .gDash {
   width: 90px;
   height: 3px;
   font-weight: bold;
   color:#00C5BC;
   background: #00C5BC;
   margin-right: 3%;
   display: inline-block;
   align-self: center;
 }
 .Mhome-Btitle {
   font-size: clamp(29px,2.5vw,38px);
   -ms-font-size: clamp(29px,2.5vw,38px);
   font-weight: bold;
   display: flex;
 }
 .header-text, .mobile-header-text {
   position: absolute;
   top: 0;
   padding: 110px 4% 0 0;
   width: 100%;
 }
 .header-text p {
   color: white;
   font-size: clamp(35px, 3.3vw, 65px);
   line-height: 1.3em;
   font-weight: bold;
   text-align: right;
   text-shadow: 6px 10px 22px black;
 }
 .mobile-header-text p {
   color: white;
   font-size: clamp(20px, 12vw, 50px);
   line-height: 1.3em;
   font-weight: bold;
   text-align: right;
   text-shadow: 6px 10px 22px black;
 }
 #about-header {
   font-size: clamp(35px, 2.6vw, 50px);
   line-height: 60px;
   font-weight: bold;
 }
 #mobile-about-header {
   display: none;
   font-size: 33px;
    margin-bottom: 50px;
    font-size: clamp(24px,4vw,38px);
   -ms-font-size: clamp(24px,4vw,38px);
 }
 .about-img {
   width: 65%;
   height: auto;
   margin: 0 auto; 
   display: block;
 }
 .aboutus-content1 {
   margin-top: 6%;
   display: flex;
   justify-content: space-between;
 }
 .about-text {
   font-size: 17px;
   margin-top: 35px;
   line-height: 32px;
   text-align: justify;
 }
 .about-text-title {
   font-weight: bold;
   font-size: clamp(20px, 1.55vw, 40px);
 }
 .aboutus-content1-left, .aboutus-content1-right {
   width: 50%;
 }
 .about-content1-right-subbox {
   background: #004884;
   width: 100%;
   padding: 5%;
   color: white;
   font-size: 24px;
   font-weight: thin;
   margin: 6% 0 8% 0;
 }
 #mobile-subbox {
   background: #004884;
   width: 100%;
   padding: 9%;
   color: white;
   font-size: 20px;
   font-weight: thin;
   margin: 80px 0 50px 0;
 }
 #mobile-about-bot, #mobile-about-text {
   display: none;
 }
 @media screen and (max-width: 1310px) {
   #header-gDash {
     width:64%;
   }
 }
 @media screen and (max-width: 900px) {
   .cont {
     padding: 0 11% 0 11%;
   }
   .header-text, .mobile-header-text {
      padding: 100px 4% 0 0;
    }
   .mobile-header-text p {
     font-size: clamp(20px,7vw,40px);
   }
   .aboutus-content1 {
     flex-direction: column;
   }
   .aboutus-content1-left, .aboutus-content1-right {
     width: 100%;
   }
   #mobile-about-header {
     display: block;
     margin: 50px 0 0 8vw;
   }
   .aboutus-header, #about-header, .about-content1-right-subbox, #about-text {
     display: none;
   }
   .mobile-img-header, #mobile-about-bot, #mobile-about-text {
     display: block;
     margin-bottom: 50px;
   }
   .gDash {
     width: 70px;
   }
   #about-title {
     display: none;
   }
 }
 @media screen and (max-width: 600px) {
   #mobile-about-header {
     display: block;
     margin: 50px 0 15px 3vw;
   }
 }
 @media screen and (max-width: 500px) {
   .cont {
     padding: 0 20px 0 20px;
   }
   .mobile-img-header {
     max-height:335px;
   }
   #mobile-about-header {
     font-size: 24px;
     line-height: unset;
     margin: 50px 0 0 8vw;
   }
   .gDash {
     width: 55px;
   }
   .mobile-header-text p {
     font-size: clamp(25px,6.4vw,35px);
   }
   .about-img {
     width: calc(80vw - 40px);
   }
   .about-text {
     font-size: 16px;
     line-height: 30px;
   }
   .about-content1-right-subbox {
     font-size: 20px;
   }
 }
 @media screen and (max-width: 335px) {
   .mobile-header-text p {
     font-size: 24px;
     line-height: 1.25em;
   }
 }
 /* @media screen and (max-width: 290px) {
   .mobile-img-header {
     margin-top:-30%;
   }
 } */
</style>
 
 
 
 

